























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import ItemDetailPO from "../../../store/entities/basedata/itemdetailpo";
@Component({
  components: { TreeSelect },
})
export default class EditDetailItem extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  itemdetail: ItemDetailPO = new ItemDetailPO();
  loading: boolean = false;
  created() {
    this.itemdetail.isEnable = 1;
    this.itemtree();
  }
  save() {
    (this.$refs.itemDetailForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "itemdetail/update",
            data: this.itemdetail,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        this.loading = false;
        (this.$refs.itemDetailForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemDetailForm as any).resetFields();
    this.$emit("input", false);
  }
  async itemtree() {
    await this.$store
      .dispatch("items/getselectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {});
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.itemdetail = Util.extend(
        true,
        {},
        this.$store.state.itemdetail.editItemdetail
      );
    }
  }
  itemRule = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    enCode: [
      {
        required: true,
        message: this.L("Encode") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      optionsMechanism: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
